module.exports = __webpack_public_path__ + "img/AYUDA.f6bc6bbf.png";